import { useEffect, useState } from 'react';
import Sheet from 'react-modal-sheet';
import close from '../assets/yettel-close.png';
import results from '../assets/rezultati.png';
import { SESSION_STORAGE_KEYS } from '../constants/sessionStorageKeys';
import '../scss/daily-prize-modal.scss';
import { PrizeResultsModal } from './PrizeResultsModal';

export const GameResultsModal = () => {
  const [isMainModalActive, setIsMainModalActive] = useState(false);
  const [isSecondaryModalActive, setIsSecondaryModalActive] = useState(false);

  const wasModalGroupShownToUser = () => {
    return sessionStorage.getItem(SESSION_STORAGE_KEYS.IS_RESULTS_MODAL_SEEN) === 'true';
  };

  const setAsSeen = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.IS_RESULTS_MODAL_SEEN, 'true');
  };

  const onCloseMainModal = () => {
    setAsSeen();
    setIsMainModalActive(false);
  };

  const onOpenSecondaryModal = () => {
    setAsSeen();
    setIsMainModalActive(false);
    setIsSecondaryModalActive(true);
  };

  useEffect(() => {
    if (!wasModalGroupShownToUser()) {
      setIsMainModalActive(true);
    }
  }, []);

  return (
    <>
      <Sheet isOpen={isMainModalActive} onClose={onCloseMainModal} className="daily-prize-modal">
        <Sheet.Container>
          <Sheet.Content>
            <PrimaryModalContent onCloseMainModal={onCloseMainModal} onOpenSecondaryModal={onOpenSecondaryModal} />
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={onCloseMainModal} />
      </Sheet>

      <PrizeResultsModal isActive={isSecondaryModalActive} setIsActive={setIsSecondaryModalActive} />
    </>
  );
};

interface PrimaryModalContentProps {
  onCloseMainModal: () => void;
  onOpenSecondaryModal: () => void;
}

const PrimaryModalContent: React.FC<PrimaryModalContentProps> = ({ onCloseMainModal, onOpenSecondaryModal }) => {
  return (
    <div className="daily-prize-modal">
      <div className="content" onClick={e => e.stopPropagation()}>
        <img className="image" src={results} alt="results image" onClick={onOpenSecondaryModal} />
        <img className="close-icon" src={close} alt="close" onClick={onCloseMainModal} width="30" height="30" />
      </div>
    </div>
  );
};
